module.exports = __webpack_public_path__ + "static/media/es-ecosentino-bathroom-days-large.03698909.png";